import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BoxLoginComponent } from '../forms/box-login/box-login.component';
import { DataService } from '../../core/services/data.service';
import { Location } from '@angular/common';
import { UtilsService } from '../../core/services/utils.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [BoxLoginComponent],
  template: '<app-box-login></app-box-login>',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  constructor(
    private router: Router,
    private utilsService: UtilsService,
    private dataService: DataService,
    private location: Location
  ) {}

  async ngOnInit() {
    const hash = this.router.url.split('#/')[1];
    if (hash) {
      const params = await this.utilsService.decryptUrlParams(hash);
      if (params?.quotation && params?.role) {
        await this.dataService.setQuotationNumber(params.quotation);
        await this.dataService.setLoginRole(params.role);
        this.location.replaceState('/');
      }
    }
    this.dataService.setInitialized(true);
  }
}